import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { StatusType } from "@trumpf/ux.ui-widgets/dist/types/components/status/status-types";
import { OverviewHeaderIntroRow } from "../../../partial-templates/overview-header/overview-header.stories";
import { addI18nTranslations } from "../../../../utils";
import { renderPageTemplate } from "../../../../utils";

const transactionFailed: StatusType = "SERVICE_CALL_TransactionFailed";
const open: StatusType = "SERVICE_CALL_Open";
const deleted: StatusType = "SERVICE_CALL_Deleted";
const closed: StatusType = "SERVICE_CALL_Closed";
const waitingForCustomer: StatusType = "SERVICE_CALL_WaitingForCustomer";
const inProcess: StatusType = "SERVICE_CALL_InProcess";
const callPredictive: StatusType = "SERVICE_CALL_call-predictive";
const newMessage: StatusType = "SERVICE_CALL_NewTechMessage";

const serviceCaseStatusLabels = {
    [transactionFailed]: "Übermittlung fehlgeschlagen",
    [open]: "Fall übermittelt",
    [deleted]: "Fall gelöscht",
    [closed]: "Fall geschlossen",
    [waitingForCustomer]: "Warten auf Rückmeldung",
    [inProcess]: "In Bearbeitung",
    [callPredictive]: "Call Predictive",
    [newMessage]: "Neue Nachricht",
};

const Template = () => {
    addI18nTranslations({
        namespace: "my-service-cases",
        language: "de-DE",
        translations: {
            filter: {
                status: {
                    placeholder: "Status",
                    values: serviceCaseStatusLabels,
                },
            },
            content: {
                status: {
                    column: "Status",
                    values: serviceCaseStatusLabels,
                },
                createdByUser: {
                    column: "Ersteller",
                },
                creationDate: {
                    column: "Datum",
                },
                fullMachineName: {
                    column: "Maschinenname",
                },
                notificationType: {
                    column: "Meldungsgrund",
                },
                sisCaseId: {
                    column: "Fallnummer",
                },
            },
        },
    });

    return html`
        <div class="ux-t-container">
            ${OverviewHeaderIntroRow({
                type: "my-service-cases",
                headline: "Meine Servicefälle",
                buttonLabel: "Neuen Fall anlegen",
                searchPlaceholder: "Fallnummer",
            })}
            <ux-sidebar
                name="filter-sidebar-1"
                close-on-esc-key="true"
                close-on-backdrop-click="true"
                transition="slide"
                alignment="right"
                disable-backdrop="false"
                disable-close-icon="false"
                align-header="false"
                align-footer="false"
                opened="false"
            >
                <ux-sidebar-content
                    class="ux-u-pb-xs ux-u-px-xs ux-u-px-md-l ux-u-mt-xxs"
                >
                    <ux-iws-stateful-filter
                        url="generated-mock-data/myservicecalls-stateful-filter.json"
                        scope="my-service-cases"
                        date-picker
                        date-format="DD.MM.YYYY"
                        range-start-label="Start date"
                        range-end-label="End date"
                        max-date="2023-12-31"
                        min-date="2023-01-01"
                        filter-column-class="ux-col-12 ux-u-mb-xs"
                        disable-tags
                    >
                    </ux-iws-stateful-filter>
                </ux-sidebar-content>
                <ux-sidebar-footer>
                    <ux-button
                        class="ux-u-mb-xxs ux-u-mx-zero ux-u-mx-md-xs"
                        variant="primary"
                        class="ux-button--full-width"
                        data-trigger-sidebar="toggle,filter-sidebar-1"
                        >Treffer anzeigen</ux-button
                    >
                    <ux-iws-stateful-filter-remove-button
                        class="ux-u-mx-zero ux-u-mx-md-xs"
                        variant="secondary"
                        scope="my-service-cases"
                        date-picker
                        date-format="DD.MM.YYYY"
                        range-start-label="Von"
                        range-end-label="Bis"
                        max-date="2023-12-31"
                        min-date="2023-01-01"
                    ></ux-iws-stateful-filter-remove-button>
                </ux-sidebar-footer>
            </ux-sidebar>
        </div>
        <div class="ux-t-container-full">
            <div class="ux-row u-background-blue-gradient ux-u-shadow-inset">
                <div class="ux-col-10 ux-u-offset-1 ux-u-mt-xs">
                    <ux-iws-async-modal
                        name="create-service-call"
                        src="mock-data/service-calls/create-service-call.html"
                    ></ux-iws-async-modal>
                    <ux-iws-stateful-filter-button
                        scope="my-service-cases"
                        date-picker
                        date-format="DD.MM.YYYY"
                        range-start-label="Von"
                        range-end-label="Bis"
                        max-date="2023-12-31"
                        min-date="2023-01-01"
                        data-trigger-sidebar="toggle,filter-sidebar-1"
                        >Filter</ux-iws-stateful-filter-button
                    >
                    <ux-iws-stateful-filter-tags
                        scope="my-service-cases"
                        date-picker
                        date-format="DD.MM.YYYY"
                        range-start-label="Von"
                        range-end-label="Bis"
                        max-date="2023-12-31"
                        min-date="2023-01-01"
                        class="ux-u-d-none ux-u-d-lg-block"
                    >
                    </ux-iws-stateful-filter-tags>
                </div>
                <ux-iws-stateful-overview
                    url="generated-mock-data/myservicecalls-stateful.json"
                    scope="my-service-cases"
                    date-picker
                    date-format="DD.MM.YYYY"
                    range-start-label="Von"
                    range-end-label="Bis"
                    max-date="2023-12-31"
                    min-date="2023-01-01"
                    debug="true"
                >
                </ux-iws-stateful-overview>
            </div>
        </div>
    `;
};

export default {
    title: "MyTrumpf/Page Templates/My Service Cases/Overview",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
        layout: "fullscreen",
    },
};

const Empty = () =>
    html` <div class="ux-t-container">
            ${OverviewHeaderIntroRow({
                type: "my-service-cases",
                headline: "My Service Cases",
                buttonLabel: "Create new case",
            })}
        </div>
        <div class="ux-t-container-full">
            <div class="ux-row u-background-blue-gradient ux-u-shadow-inset">
                <ux-iws-stateful-overview
                    url="generated-mock-data/myservicecalls-stateful-empty.json"
                    scope="my-service-cases"
                >
                </ux-iws-stateful-overview>
            </div>
        </div>`;

export const Default = () => renderPageTemplate(() => Template());

export const NoResults = () => renderPageTemplate(() => Empty());
